import { ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AirdiskbrakeService } from 'src/app/services/feature/airdisk-brake/airdiskbrake.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-airdisk-csa-violation-costs',
  templateUrl: './airdisk-csa-violation-costs.component.html',
  styleUrls: ['./airdisk-csa-violation-costs.component.scss'],
  standalone: false
})
export class AirdiskCsaViolationCostsComponent {
  private readonly destroy$ = new Subject<void>();
  fleetInfoData: any;
  subscription = new Subscription();
  isTractor: boolean = false;
  constructor(public airdiskService: AirdiskbrakeService, private readonly cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.subscription = this.airdiskService.selectedOption$.subscribe(option => {
      if (option) {
        this.isTractor = option === 'Tractor';
      } else {
        this.isTractor = true;
      }
    });

    this.airdiskService.fleetInfoData$.subscribe(x => {
      this.fleetInfoData = x;
    });

    this.airdiskService.csaViolation$.pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        if (data != null) {
          this.csaViolationForm.patchValue({
            csaViolationsAnnualPercentage: data.csaViolationsAnnualPercentage || 10,
            noOfCSAViolations: data.noOfCSAViolations || 100,
            roadSideCallRateForCSAViolations: data.roadSideCallRateForCSAViolations.toFixed(2) || 2000.00,
            annualnoOfOutOfServiceBreakCSAViolations: data.annualnoOfOutOfServiceBreakCSAViolations || 13,
            csaUnitCost: data.csaUnitCost || 198.25,
            lifeCycleCSAFleetCost: data.lifeCycleCSAFleetCost || 198250,
          });
        }

      });
    this.calculateAndSetSum();
  }

  csaViolationForm = new FormGroup({
    csaViolationsAnnualPercentage: new FormControl(10, { validators: Validators.required }),
    noOfCSAViolations: new FormControl(100, { validators: Validators.required }),
    roadSideCallRateForCSAViolations: new FormControl(2000.00, { validators: Validators.required }),
    annualnoOfOutOfServiceBreakCSAViolations: new FormControl(13, { validators: Validators.required }),
    csaUnitCost: new FormControl(198.25, { validators: Validators.required }),
    lifeCycleCSAFleetCost: new FormControl(198250, { validators: Validators.required }),
  });

  get form() {
    return this.csaViolationForm.controls;
  }

  onFormChanges(): void {
    this.csaViolationForm.get('csaViolationsAnnualPercentage')?.valueChanges.subscribe(() => {
      this.calculateAndSetSum();
    });

    this.csaViolationForm.get('roadSideCallRateForCSAViolations')?.valueChanges.subscribe(() => {
      this.calculateAndSetSum();
    });

    this.storeDataOnChange();
  }

  calculateAndSetSum(): void {


    //Fleet Information:
    const E13 = this.fleetInfoData?.fleetSize;
    const E15 = this.isTractor ? this.fleetInfoData?.tractorTradeInCycle : this.fleetInfoData?.trailerTradeInCycle
    const E21 = this.fleetInfoData?.fleetDownTimeRate;


    // csa-vioalation-costs
    const E46 = +this.csaViolationForm.get('csaViolationsAnnualPercentage')?.value || 0;      //Average Mileage to Change Friction
    const E47 = +this.csaViolationForm.get('roadSideCallRateForCSAViolations')?.value || 0;      //Average Mileage to Change Friction


    const E48 = Math.floor((E46 / 100) * E13);
    const E49 = Math.round((E48 * 13) / 100);
    const E51 = (E49 * E47 + E49 * E21) * E15;
    const E50 = E51 / E13;

    this.csaViolationForm.patchValue({
      noOfCSAViolations: E48,
      annualnoOfOutOfServiceBreakCSAViolations: E49,
      csaUnitCost: E50,
      lifeCycleCSAFleetCost: Number(E51.toFixed(2))
    });

  }

  storeDataOnChange() {

    if (this.csaViolationForm.valid) {

      this.csaViolationForm.patchValue({
        csaViolationsAnnualPercentage: Number(this.csaViolationForm.controls['csaViolationsAnnualPercentage'].value),
        noOfCSAViolations: Number(this.csaViolationForm.controls['noOfCSAViolations'].value),
        roadSideCallRateForCSAViolations: Number(this.csaViolationForm.controls['roadSideCallRateForCSAViolations'].value),
        annualnoOfOutOfServiceBreakCSAViolations: Number(this.csaViolationForm.controls['annualnoOfOutOfServiceBreakCSAViolations'].value),
        csaUnitCost: Number(this.csaViolationForm.controls['csaUnitCost'].value),
        lifeCycleCSAFleetCost: Number(this.csaViolationForm.controls['lifeCycleCSAFleetCost'].value),
      });
      this.airdiskService.csaViolation$.next(this.csaViolationForm.value);
    }
    else {
      this.csaViolationForm.markAllAsTouched();
    }
    this.cdr.detectChanges();
  }

  endaSureNxt() {
    this.storeDataOnChange();
    this.airdiskService.currentComponent$.next('rustMaintainance');
  }

  endaSureBack() {
    this.airdiskService.currentComponent$.next('drumBreakCosts');
    this.storeDataOnChange();
  }

  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.subscription.unsubscribe();
  }
}
